import { open, restore } from "./launcher";

export interface ChatLauncher {
  /** Opens the web chat surface. */
  open(): Promise<void>;
  /** Restores a web conversation, or does nothing for an empty ID. */
  restore(sessionId: string): Promise<void>;
}

export const chatClientSdkLauncher: ChatLauncher = {
  open,
  restore,
};

export default chatClientSdkLauncher;
